export default "__VITE_ASSET__Brl$vrAU__"